<template>
    <div>
        <rkm-form ref="Form">
            <rkm-tabs v-model="tabIndex">

                 <rkm-tab
                    title="JORNADAS CADASTRADAS"
                    @click.prevent="setActive('JornadasCadastradas')"
                >
                    <tab-jornadas-cadastradas
                        ref="TabJornadasCadastradas"
                        :form="form"
                        :model="model"
                        :profissional="profissional"
                        @handleAlter="handleAlter"
                        @getDays="getDays"
                        @deleteJornada="handleDeleteJornada"
                    />
                </rkm-tab>

                <rkm-tab
                    title="CADASTRAR JORNADA"
                    @click.prevent="setActive('InclusaoJornada')"
                >
                    <tab-inclusao-jornada
                        ref="TabInclusaoJornada"
                        :form="form"
                        :model="model"
                        :profissional="profissional"
                        :jornada="jornada"
                        :diasCalendario="diasCalendario"
                        :index="index"
                        @backTabs="backTabs"
                        @backTabsNotification="backTabsNotification"
                        @getDiasCalendario="getDiasCalendario"
                        @handleAlter="handleAlter"
                    />
                </rkm-tab>
            </rkm-tabs>
        </rkm-form>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

//Moment
import moment from 'moment'

// Mixins.
import { formats, repository, stringCase, object, error } from '@/mixins'

// Enuns.
import statusJornada from '@/enums/exame-imagem/statusJornada'
import modulo from '@/enums/cadastro/feriado/modulo'

// Components.
import TabJornadasCadastradas from '@/components/exame-imagem/jornada/components/Index'
import TabInclusaoJornada from '@/components/exame-imagem/jornada/components/cadastro/Form'

export default {
    components: {
        TabJornadasCadastradas,
        TabInclusaoJornada,
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('exameImagem.jornada'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
        },
        this.load()
    },
    data: () => ({
        form: {
            profissional: {
                nome: '',
                dataNascimento: '',
                cpf: ''
            }
        },
        model: {
            cadastro: [],
            inclusao: [],
            usuarioId: null,

        },
        enums: {
            statusJornada,
            modulo
        },
        tabIndex: 0,
        index: null,
        profissional: {
            nome: null,
            dataNascimento: null,
            cpf: null,
        },
        jornada: {
            agendamentos: false,
            data: null,
            diasSemana: null,
            exameId: null,
            exameNome: '',
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            jornadaId: null,
            statusId: null,
            statusNome: '',
            semanaId: null,
            selecionado: false,
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            usuarioId: '',
            vagas: '',
            vagasApp: '',
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
            controleJornadaId: null,
            supervisorId: null,
            novaJornada: false,
            editJornada: false,
            deleteJornada: []
        },
        diasCalendario: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.jornada.show(this.id)
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.$nextTick().then(() => {

                        this.tabRefs = [
                            this.$refs.TabJornadasCadastradas,
                            this.$refs.TabInclusaoJornada,
                        ]
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
                })
                .catch(this.handleError)
        },
        setJornada(){
            this.jornada = {
                data: null,
                diasSemana: [],
                exameId: null,
                exameNome: '',
                horaInicial: '',
                horaFim: '',
                infraestruturaId: null,
                infraestruturaNome: '',
                jornadaId: null,
                statusId: null,
                statusNome: '',
                semanaId: null,
                selecionado: false,
                tempoAtendimento: '',
                tipoId: null,
                tipoNome: null,
                unidadeId: null,
                unidadeNome: '',
                unidadeDisabled: false,
                usuarioId: '',
                vagas: '',
                vagasApp: '',
                prestadorInfraestruturaId: null,
                periodo: {
                    start: null,
                    end: null,
                },
                prestadorId: null,
                prestadorNome: '',
                controleJornadaId : null,
                agendamentos: false
            }
            this.jornada.statusId = this.enums.statusJornada.ATIVO
        },
        setActive(){

            this.setJornada()
            this.index = null
        },
        handleDeleteJornada(id){
            if(!this.jornada.deleteJornada.includes(id)){
                this.jornada.deleteJornada.push(id)
            }
        },
        save() {

            this.setLoading()
            this.repositories.jornada.store(this.prepareData())
                .then(() => {
                    this.showSaveNotification()
                    this.load()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },


        prepareData(){
            let jornadas = []

            const jornadasAlteradas = this.model.jornadas
                .filter(jornada => jornada.editJornada || jornada.novaJornada)
                .map(jornada => {
                    return {
                        jornadaId: jornada.jornadaId,
                        usuarioId: jornada.usuarioId,
                        unidadeId: jornada.unidadeId,
                        controleJornadaId: jornada.controleJornadaId,
                        infraestruturaId: jornada.infraestruturaId,
                        exameId: jornada.exameId,
                        exameNome: jornada.exameNome,
                        semanaId: jornada.semanaId,
                        diassemana: jornada.diasSemana,
                        statusId: jornada.statusId,
                        tipoId: jornada.tipoId,
                        data: jornada.data,
                        horaInicial: jornada.horaInicial,
                        horaFim: jornada.horaFim,
                        vagas: jornada.vagas,
                        tempoAtendimento: jornada.tempoAtendimento,
                        prestadorId: jornada.prestadorId,
                        prestadorNome: jornada.prestadorNome,
                        novaJornada: jornada.novaJornada,
                    }
            })

            const jornadasNotSave = (this.model.jornadasNotSave || []).map(jornada => {
                return {
                    jornadaId: jornada.jornadaId,
                    usuarioId: jornada.usuarioId,
                    unidadeId: jornada.unidadeId,
                    controleJornadaId: jornada.controleJornadaId,
                    infraestruturaId: jornada.infraestruturaId,
                    exameId: jornada.exameId,
                    exameNome: jornada.exameNome,
                    semanaId: jornada.semanaId,
                    diassemana: jornada.diasSemana,
                    statusId: jornada.statusId,
                    tipoId: jornada.tipoId,
                    data: jornada.data,
                    horaInicial: jornada.horaInicial,
                    horaFim: jornada.horaFim,
                    vagas: jornada.vagas,
                    vagasApp: jornada.vagasApp,
                    tempoAtendimento: jornada.tempoAtendimento,
                    prestadorId: jornada.prestadorId,
                    prestadorNome: jornada.prestadorNome,
                }
            })

            jornadas = [
                ...jornadasAlteradas,
                ...jornadasNotSave
            ]

            return this.camelObjectKeysToSnakeRecursive({
                jornadas, 
                jornadasDelete: this.jornada.deleteJornada,
                usuarioId: this.usuarioId,
            })
        },
        handleAlter(item) {

            this.showConfirmation(
                'Existem agendamentos vinculados à jornada. Deseja continuar?',
                async () => {

                    this.jornada = item
                    this.index = true

                    this.jornada.periodo.start = moment(item.data, 'YYYY-MM-DD').toDate()
                    this.jornada.periodo.end = moment(item.data, 'YYYY-MM-DD').toDate()

                    this.tabIndex = 1
                },
            )
        },
        backTabs(){

            const jornada = this.clone(this.jornada)

            if(jornada.jornadaId != null){

                this.tabIndex = 0
            }

            this.setJornada()
        },
        backTabsNotification(){

            const jornada = this.clone(this.jornada)

            this.setJornada()

            if(jornada.jornadaId != null){

                this.showSaveNotification('Registro da jornada selecionada alterada com sucesso.')

            } else {

                this.showSaveNotification('Registro da jornada adicionada.')
            }
        },
        validate() {
            return this.tabRefs[this.tabIndex].validate()
        },
        getDays(value) {
            this.model.jornadas = value

            let diasCalendario = []

            value.map(unidade => diasCalendario.push({
                'dates': moment(unidade.data, 'YYYY/MM/DD').toDate(),
                'title': 'icon-search',
                'highlight': 'green'
            }))

            this.form.feriados.map(feriado =>

                feriado.modulos.map(modulo => {

                    if(modulo == this.enums.modulo.EXAME_IMAGEM){

                        diasCalendario.push({
                            'dates': moment(feriado.data, 'DD/MM/YYYY').toDate(),
                            'highlight': 'yellow',
                            'title': feriado.tipoNome,
                            'popover':  feriado.observacao
                        })
                    }
                })
            )

            this.getDiasCalendario(diasCalendario)
        },
        getDiasCalendario(value) {

            this.diasCalendario = value
        },
    },
    mixins: [formats, repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>

<style>
.tabs {
    border: 0px solid #dee2e6!important;
    border-radius: 0.25rem;
}
</style>